/* eslint-disable no-unused-vars */
export const BASE_URL = 'http://www.laotraisla.net/media';

// Artist names as used in the filesystem and application data
export const ABEL = 'abel';
export const CELIA_YUNIOR = 'celia-yunior';
export const CRISTINA = 'cristina';
export const FIDEL_GARCIA = 'fidel-garcia';
export const HENRI_ERIC = 'henri-eric';
export const HUMBERTO_DIAZ = 'humberto-diaz';
export const JAVIER_CASTRO = 'javier-castro';
export const JORGE_RODRIGUEZ = 'jorge-rodriguez';
export const LUIS_MANUEL = 'luis-manuel';
export const MAGALY_ESPINOSA = 'magaly-espinosa';
export const MOSQUERA = 'mosquera';
export const NESTOR = 'nestor';
export const REYNIER_LEYVA = 'reynier-leyva';
export const RODOLFO_PERAZA = 'rodolfo-peraza';
export const SANDRA_CEBALLOS = 'sandra-ceballos';
export const SANDRA_RAMOS = 'sandra-ramos';
export const TANYA = 'tanya';
export const TOIRAC = 'toirac';
export const YANELIS = 'yanelis';

export const FULL_MOSQUERA = 'Gerardo Mosquera';
export const FULL_NESTOR = 'Nestor Siré';
export const FULL_HENRI_ERIC = 'Henry Eric Hernández';
export const FULL_HUMBERTO_DIAZ = 'Humberto Díaz';
export const FULL_SANDRA_CEBALLOS = 'Sandra Ceballos';
export const FULL_RODOLFO_PERAZA = 'Rodolfo Peraza';
export const FULL_YANELIS = 'Yanelys Nuñez Leyva ';
export const FULL_CELIA_YUNIOR = 'Celia-Yunior';
export const FULL_SANDRA_RAMOS = 'Sandra Ramos';
export const FULL_FIDEL_GARCIA = 'Fidel García';
export const FULL_ABEL = 'Abel Barroso';
export const FULL_CRISTINA = 'Cristina Figueroa Vives';
export const FULL_LUIS_MANUEL = 'Luis Manuel Otero';
export const FULL_JAVIER_CASTRO = 'Javier Castro';
export const FULL_MAGALY_ESPINOSA = 'Magaly Espinosa';
export const FULL_JORGE_RODRIGUEZ = 'Jorge Braulio Rodríguez';
export const FULL_TOIRAC = 'José Ángel Toirac';
export const FULL_REYNIER_LEYVA = 'Reynier Leyva "chino" Novo';
export const FULL_TANYA = 'Tania Bruguera';

// Categories
export const CENSURA = 'censura';
export const CONTEXTO = 'contexto';
export const FORMACION = 'formacion';
export const MERCADO = 'mercado';
export const OBRA = 'obra';
export const CATEGORIES = [CENSURA, CONTEXTO, FORMACION, MERCADO, OBRA];

// Options
export const SVG_IMAGE_WIDTH = 197;
export const SVG_IMAGE_HEIGHT = 111;
export const ZOOM_VALUE = 2.5;

const CONSTANTS = [
  ABEL,
  CATEGORIES,
  CELIA_YUNIOR,
  CENSURA,
  CONTEXTO,
  CRISTINA,
  FIDEL_GARCIA,
  FORMACION,
  HENRI_ERIC,
  HUMBERTO_DIAZ,
  JAVIER_CASTRO,
  JORGE_RODRIGUEZ,
  LUIS_MANUEL,
  MAGALY_ESPINOSA,
  MERCADO,
  MOSQUERA,
  NESTOR,
  OBRA,
  REYNIER_LEYVA,
  RODOLFO_PERAZA,
  SANDRA_CEBALLOS,
  SANDRA_RAMOS,
  SVG_IMAGE_HEIGHT,
  SVG_IMAGE_WIDTH,
  TANYA,
  TOIRAC,
  YANELIS,
  ZOOM_VALUE,
];
export default CONSTANTS;
